import React from 'react';

import {
  FuelGridContainer,
  FuelGridItem,
  FuelSkeleton,
} from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import SkeletonOriginAndDestination from '../../../../Skeleton/SkeletonOriginAndDestination';
import * as Styled from './SkeletonListAllTabStyles';

interface SkeletonPropsInterface {
  borderBottom?: boolean;
  skeletonHeader?: boolean;
  marginBottom?: boolean;
}

function SkeletonListAllTab({
  borderBottom,
  skeletonHeader = false,
  marginBottom = false,
}: SkeletonPropsInterface) {
  return (
    <>
      {skeletonHeader && (
        <FuelSkeleton shape="square" size="custom" width="100%" height="38px" />
      )}
      <Styled.WrapperStyledFuelGridContainer
        borderBottom={borderBottom}
        marginBottom={marginBottom}
      >
        <FuelGridContainer gapRow={0}>
          <FuelGridItem sm={2} md={5} lg={4} xlg={4}>
            <Styled.ColumnOne>
              <Styled.Wrapper>
                <Styled.Item>
                  <FuelSkeleton
                    shape="circle"
                    size="custom"
                    width="40px"
                    height="40px"
                  />
                </Styled.Item>
                <Styled.Item>
                  <FuelSkeleton
                    shape="text"
                    size="custom"
                    width="89px"
                    height="16px"
                  />
                  <Styled.WrapperOriginAndDestination>
                    <Styled.Item>
                      <SkeletonOriginAndDestination />
                    </Styled.Item>
                    <Styled.Item>
                      <FuelSkeleton
                        shape="text"
                        size="custom"
                        width="72px"
                        height="16px"
                      />
                      <FuelSkeleton
                        shape="text"
                        size="custom"
                        width="72px"
                        height="16px"
                      />
                    </Styled.Item>
                  </Styled.WrapperOriginAndDestination>
                </Styled.Item>
              </Styled.Wrapper>
            </Styled.ColumnOne>
          </FuelGridItem>
          <FuelGridItem sm={2} md={4} lg={3} xlg={3}>
            <Styled.ColumnTwo>
              <Styled.Item>
                <FuelSkeleton
                  shape="text"
                  size="custom"
                  width="89px"
                  height="16px"
                />
                <FuelSkeleton
                  shape="text"
                  size="custom"
                  width="108px"
                  height="16px"
                />
              </Styled.Item>
            </Styled.ColumnTwo>
          </FuelGridItem>

          <FuelGridItem sm={3} md={4} lg={5} xlg={5}>
            <FuelFlex
              defaultProps={{
                alignItems: 'center',
                gap: 'km4',
                justifyContent: 'flex-end',
              }}
            >
              <FuelSkeleton
                shape="square"
                size="custom"
                width="80px"
                height="32px"
              />
              <FuelSkeleton
                shape="square"
                size="custom"
                width="80px"
                height="32px"
              />
              <FuelSkeleton
                shape="square"
                size="custom"
                width="24px"
                height="24px"
              />
              <FuelSkeleton
                shape="square"
                size="custom"
                width="24px"
                height="24px"
              />
            </FuelFlex>
          </FuelGridItem>
        </FuelGridContainer>
      </Styled.WrapperStyledFuelGridContainer>
    </>
  );
}

export default SkeletonListAllTab;
